module.exports = __webpack_public_path__ + "static/media/fisher_dunn.30245108.jpg";